var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('strong',[_vm._v(_vm._s(_vm.coveredProvider))])]),_c('td',[_vm._v(" "+_vm._s(_vm.primary)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.secondary)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }